export default __webpack_public_path__ + "static/media/capital_section_image_desktop.0013ac70.jpg";